import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { exchangeCanvaCode } from "@/lib/canva-client"
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react"

export default function CanvaCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading")
  const [errorMsg, setErrorMsg] = useState("")

  useEffect(() => {
    const code = searchParams.get("code")
    const state = searchParams.get("state")

    if (!code || !state) {
      setStatus("error")
      setErrorMsg("Missing authorization code or state parameter")
      return
    }

    exchangeCanvaCode(code, state)
      .then(() => {
        setStatus("success")
        setTimeout(() => navigate("/dashboard/settings"), 2000)
      })
      .catch((err) => {
        setStatus("error")
        setErrorMsg(err.message || "Failed to connect Canva account")
      })
  }, [searchParams, navigate])

  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="flex flex-col items-center gap-4 text-center">
        {status === "loading" && (
          <>
            <Loader2 className="h-10 w-10 animate-spin text-primary" />
            <h2 className="text-lg font-semibold text-foreground">Connecting Canva...</h2>
            <p className="text-sm text-muted-foreground">Please wait while we complete the connection.</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="h-10 w-10 text-emerald-500" />
            <h2 className="text-lg font-semibold text-foreground">Canva Connected!</h2>
            <p className="text-sm text-muted-foreground">Redirecting to settings...</p>
          </>
        )}
        {status === "error" && (
          <>
            <AlertCircle className="h-10 w-10 text-red-500" />
            <h2 className="text-lg font-semibold text-foreground">Connection Failed</h2>
            <p className="text-sm text-muted-foreground">{errorMsg}</p>
            <button
              onClick={() => navigate("/dashboard/settings")}
              className="mt-4 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
            >
              Back to Settings
            </button>
          </>
        )}
      </div>
    </div>
  )
}
